/* eslint-disable */ import { detailComponent, memoEval, sceneEntityObjectPropertiesComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const endPanelComponents = [
    attachComponent.withComponent(detailComponent, 'default', true).withEntity('EndPanel').attach(memoEval((self)=>[
            self.$name,
            self.$sku,
            self.$description
        ], ($name, $sku, $description)=>({
            title: $name,
            subtitle: $sku,
            description: $description
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'endPanel', true).withEntity('EndPanel').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'END_PANEL',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'endPanel', true).withEntity('EndPanel').attach(memoEval((self)=>[
            self.$endPanelOffsetY,
            self.$endPanelOffsetZ,
            self.$endPanelDepth,
            self.$endPanelDepthScaleZero,
            self.$endPanelDepthScaleOne,
            self.$endPanelHeight,
            self.$endPanelHeightScaleZero,
            self.$endPanelHeightScaleOne
        ], ($endPanelOffsetY, $endPanelOffsetZ, $endPanelDepth, $endPanelDepthScaleZero, $endPanelDepthScaleOne, $endPanelHeight, $endPanelHeightScaleZero, $endPanelHeightScaleOne)=>({
            offsetX: 1 * 25.4,
            offsetY: $endPanelOffsetY,
            offsetZ: $endPanelOffsetZ,
            morphTargetInfluences: {
                Depth: {
                    value: $endPanelDepth,
                    scaleZero: $endPanelDepthScaleZero,
                    scaleOne: $endPanelDepthScaleOne
                },
                Height: {
                    value: $endPanelHeight,
                    scaleZero: $endPanelHeightScaleZero,
                    scaleOne: $endPanelHeightScaleOne
                }
            }
        })))
];

//# sourceMappingURL=end-panel.js.map